<toast-notification #toastNotification></toast-notification>

<div class="acs-row acs-row--gap-lg">
  <div class="acs-col--full">
    <div class="acs-toolbar-scroll">
      <!-- Toolbar -->
      <div class="acs-toolbar">
        <div class="acs-flex acs-flex--center acs-gap-sm">
          <div class="acs-flex acs-flex--center">
            <i class="fa-solid fa-building acs-dropdown__icon" title="Trade Unit"></i>
            <div class="acs-dropdown" (click)="$event.stopPropagation()">
              <button type="button" class="acs-dropdown__trigger" (click)="toggleLocDropdown()"
                      [class.acs-dropdown__trigger--placeholder]="!locDropdown.selectedValue">
                {{locDropdown.displayText}}
                <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
              </button>
              <div class="acs-dropdown__panel" *ngIf="locDropdown.isOpen()">
                <input class="acs-dropdown__search" type="text" placeholder="Search..."
                       [ngModel]="locDropdown.searchText()" (ngModelChange)="locDropdown.searchText.set($event)"
                       (click)="$event.stopPropagation()" />
                <div class="acs-dropdown__options">
                  <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                       (click)="selectLocOption(null)">-- Select Trade Unit --</div>
                  <div *ngFor="let loc of locDropdown.filtered"
                       class="acs-dropdown__option"
                       [class.acs-dropdown__option--selected]="loc.value === locDropdown.selectedValue"
                       (click)="selectLocOption(loc)">{{loc.text}}</div>
                  <div *ngIf="locDropdown.filtered.length === 0" class="acs-dropdown__empty">No matches</div>
                </div>
              </div>
            </div>
          </div>
          <div class="acs-flex acs-flex--center" *ngIf="locDropdown.selectedValue">
            <i class="fa-solid fa-search acs-dropdown__icon" title="Filter commodities"></i>
            <input type="text" class="acs-input acs-input--compact"
                   placeholder="Filter commodities..."
                   [(ngModel)]="commoditySearchText">
          </div>
        </div>
        <div class="acs-toolbar__actions">
          <small *ngIf="locDropdown.selectedValue" class="acs-text-muted">
            {{includedCount}} of {{totalCount}} included
          </small>
          <button type="button" class="acs-action-btn acs-action-btn--accent"
                  (click)="saveCommodities()"
                  [disabled]="!locDropdown.selectedValue || !hasUnsavedChanges || saving">
            <i class="fa-solid fa-check"></i> Save
          </button>
        </div>
      </div>

      <!-- Empty state -->
      <div *ngIf="!locDropdown.selectedValue" class="acs-table-wrap--connected acs-empty-state-wrap">
        <div class="acs-empty-state">
          <i class="fa-solid fa-wheat-awn"></i>
          Select a trade unit to view commodity configuration
        </div>
      </div>

      <!-- Commodity Toggle Table -->
      <div *ngIf="locDropdown.selectedValue" class="acs-table-wrap acs-table-wrap--connected acs-table--contained">
        <table class="acs-table acs-table--striped acs-table--hover acs-table--bordered">
          <thead class="acs-thead--primary acs-sticky">
            <tr>
              <th style="width: 70px;" class="text-center">Include</th>
              <th style="width: 100px;">Code</th>
              <th>Short Description</th>
              <th>Description</th>
              <th style="width: 80px;">UOM</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loading">
              <td colspan="5" class="acs-empty-cell">Loading...</td>
            </tr>
            <ng-container *ngIf="!loading">
              <tr *ngFor="let row of filteredCommodityRows"
                  (click)="toggleCommodity(row.commodityCode)"
                  class="acs-cursor-pointer"
                  [class.acs-tr--active]="row.included">
                <td class="text-center" (click)="$event.stopPropagation(); toggleCommodity(row.commodityCode)">
                  <input type="checkbox" [checked]="row.included">
                </td>
                <td>{{row.commodityCode}}</td>
                <td>{{row.shortDescription}}</td>
                <td>{{row.description}}</td>
                <td>{{row.uom}}</td>
              </tr>
              <tr *ngIf="filteredCommodityRows.length === 0">
                <td colspan="5" class="acs-empty-cell">No commodities match the filter.</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
